export default {
  appPopupTitle: {
    id: 'lead_collection_app_popup_title',
    defaultMessage: 'It’s easier with the app.',
  },
  appPopupDescription: {
    id: 'lead_collection_app_popup_description',
    defaultMessage:
      'Scan the QR code and download the Back Market app for care tips, price drops, order tracking, and more.',
  },
  appPopupTermsTitle: {
    id: 'lead_collection_app_popup_terms_title',
    defaultMessage: '',
  },
  appPopupTermsDescription: {
    id: 'lead_collection_app_popup_terms_description',
    defaultMessage: '',
  },
}
